import script from "./DesktopDrawsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopDrawsSection.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopDrawsSection.vue?vue&type=style&index=0&id=6552a1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6552a1c4"]])

export default __exports__